import "./MessageBody.scss"

import React from "react"

import { EMOTICON, VISITOR_COUNT } from "@shared/constants"
import { useChatInfo } from "@shared/contexts"
import { Message } from "@shared/hooks/useMessages"
import {
  escapeHtml,
  mentionify,
  urlify,
  urlifyCustomerCenterImage,
} from "@shared/modules"

import { CheckText } from "./CheckButton"
import Emoji from "./Emoji"
import ImageMore from "./messages/ImageMore"
import StreamCheckEmoji from "./StreamCheckEmoji"

interface Props {
  message: Message
  messagesRef: React.RefObject<HTMLParagraphElement>
  isStreamerMessage?: boolean
  onImageLoad?: () => void
}

function MessageBody({
  messagesRef,
  message,
  isStreamerMessage = false,
  onImageLoad,
}: Props) {
  const { isSearchBarEnabled } = useChatInfo()

  if (message.isWelcome) {
    return urlifyCustomerCenterImage(mentionify(escapeHtml(message.body)))
  }

  if (VISITOR_COUNT.includes(message.emoji)) {
    return (
      <>
        {message.body}
        <Emoji name={message.emoji} width="100%" height="100%" fileExt="png" />
      </>
    )
  }

  if (EMOTICON.includes(message.emoji)) {
    return <Emoji name={message.emoji} width={70} height={70} />
  }
  if (isSearchBarEnabled) {
    return message.beautifulBody
  }

  if (message.imageUrl && message.imageUrl.length > 0) {
    return (
      <ImageMore src={message.imageUrl}>
        <img
          src={message.imageUrl}
          alt=""
          loading="lazy"
          decoding="async"
          onLoad={() => {
            onImageLoad && onImageLoad()
          }}
        />
      </ImageMore>
    )
  }
  if (isStreamerMessage) {
    return urlify(mentionify(escapeHtml(message.body)))
  }

  if (message.emoji && message.emoji.startsWith(CheckText)) {
    return <StreamCheckEmoji message={message} />
  }

  return message.body
}

export default MessageBody
